import * as React from 'react';
import Typography from '@mui/material/Typography';
import Breadcrumbs from '@mui/material/Breadcrumbs';
import PropTypes from 'prop-types';
import { Link } from 'react-router-dom';
import { Skeleton } from '@mui/material';

const propTypes = {
  projectName: PropTypes.string,
};
const defaultProps = {
  projectName: '',
};

const BasicBreadCrumbs = ({ projectName }) => (
  <Breadcrumbs className="breadcrumb-main" aria-label="breadcrumb">
    <Link className="breadcrumb-link" to="/projects">
      Project
    </Link>
    {
      projectName
        ? <Typography className="breadcrumb-current" underline="none">{projectName}</Typography>
        : <Skeleton animation="wave" variant="text" height={16} width={60} />
    }
  </Breadcrumbs>
);

BasicBreadCrumbs.propTypes = propTypes;
BasicBreadCrumbs.defaultProps = defaultProps;
export default BasicBreadCrumbs;
